<template>
  <div class="one-news-edit">
    <oneNewsLayout>
      <div class="text-right">
        <b-button
          @click="isEditing = !isEditing"
          type="button"
          variant="primary"
          >編輯</b-button
        >
      </div>
      <b-form>
        <b-form-group
          label="標題"
          label-for="one-news-edit-title"
          class="required-icon-star"
        >
          <b-form-input
            id="one-news-edit-title"
            :value="$store.getters.oneNews.title"
            @input="$store.commit('oneNewsTitle', $event)"
            :state="verifyTitle"
            :title="'請輸入值'"
            type="text"
            :disabled="!isEditing"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="發布日期" class="required-icon-star">
          <b-form-datepicker
            :value="$store.getters.oneNews.released_at"
            @input="$store.commit('oneNewsReleasedAt', $event)"
            :state="verifyDate"
            :title="'請輸入值'"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
            placeholder="請選擇新聞發布日期，非此刻新增日期"
            :disabled="!isEditing"
          >
          </b-form-datepicker>
        </b-form-group>
        <b-form-group
          label="內容"
          label-for="one-news-edit-content"
          class="required-icon-star"
        >
          <b-form-textarea
            id="one-news-edit-content"
            :value="$store.getters.oneNews.content"
            @input="$store.commit('oneNewsContent', $event)"
            :state="verifyContent"
            :title="'輸入格式有誤'"
            rows="15"
            :disabled="!isEditing"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="附件 ( 總容量上限 2048 KB )"
          label-for="one-news-edit-files"
        >
          <p>
            <span>目前容量：{{ sumOfSize }} KB</span>
            <span v-if="sumOfSize > maxSize" class="warn">超過上限</span>
          </p>
          <input
            id="one-news-edit-files"
            type="file"
            multiple
            accept=".png,.pdf,.txt,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            @change="handleFormDataFiles($event)"
            :disabled="!isEditing"
          />
        </b-form-group>
        <ul v-if="$store.getters.oneNews.files.length > 0">
          <li
            v-for="(file, index) in $store.getters.oneNews.files"
            :key="index"
          >
            <a :href="file.url" target="_blank" :download="file.name">{{
              file.name
            }}</a>
          </li>
        </ul>
        <div class="text-right">
          <b-button
            class="mr-3"
            type="button"
            variant="primary"
            @click="verifyForm"
            :disabled="!isEditing"
            >修改</b-button
          >
          <b-button
            class="mr-3"
            type="button"
            variant="dark"
            @click="$router.push({ name: 'news-owner' })"
            :disabled="!isEditing"
            >取消</b-button
          >
        </div>
      </b-form>
    </oneNewsLayout>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
import oneNewsLayout from "@/layout/OneNewsLayout.vue";
export default {
  mixins: [mixinsVerify],
  components: {
    oneNewsLayout
  },
  data() {
    return {
      verifyTitle: null,
      verifyDate: null,
      verifyContent: null,
      fileList: [],
      formData: new FormData(),
      isEditing: false
    };
  },
  computed: {
    sumOfOriginalSize() {
      if (this.$store.getters.oneNews.files.length === 0) return 0;
      let totalSize = 0;
      this.$store.getters.oneNews.files.forEach(file => {
        totalSize += file.size;
      });
      // return KB
      let totalKBSize = totalSize / 1024;
      return totalKBSize.toFixed(2);
    },
    sumOfNewUploadSize() {
      if (this.fileList.length === 0) return 0;
      let totalSize = 0;
      this.fileList.forEach(file => {
        totalSize += file.size;
      });
      // return KB
      let totalKBSize = totalSize / 1024;
      return totalKBSize.toFixed(2);
    },
    sumOfSize() {
      let totalKBSize =
        Number(this.sumOfOriginalSize) + Number(this.sumOfNewUploadSize);
      return totalKBSize.toFixed(2);
    },
    maxSize() {
      //maxSize = 2MB = 2048 KB
      return 2 * 1024;
    }
  },
  methods: {
    verifyForm() {
      this.verifyTitle = this.hasValue(this.$store.getters.oneNews.title);
      this.verifyDate = this.hasValue(this.$store.getters.oneNews.released_at);
      this.hasValue(this.$store.getters.oneNews.content) &&
        this.introductionRegexp(this.$store.getters.oneNews.content);
      if (
        this.verifyTitle === false ||
        this.verifyDate === false ||
        this.verifyContent === false ||
        this.sumOfSize > this.maxSize
      )
        return;
      else this.submit();
    },
    handleFormDataFiles(event) {
      this.fileList = [...event.target.files];
      if (this.fileList.length === 0 || this.formData.has("file[]")) {
        this.formData.delete("file[]");
      }
      this.fileList.forEach(file => {
        this.formData.append("file[]", file);
      });
    },
    handleFormData() {
      //from YYYY-MM-DD format to YYYY/MM/DD
      let regex = /-/gi;
      const dateFormat = this.$store.getters.oneNews["released_at"].replace(
        regex,
        "/"
      );
      this.formData.append("released_at", dateFormat);

      this.formData.append("news_title", this.$store.getters.oneNews["title"]);

      this.formData.append(
        "news_content",
        this.$store.getters.oneNews["content"]
      );
    },
    updateFormData() {
      //from YYYY-MM-DD format to YYYY/MM/DD
      let regex = /-/gi;
      const dateFormat = this.$store.getters.oneNews["released_at"].replace(
        regex,
        "/"
      );
      this.formData.set("released_at", dateFormat);

      this.formData.set("news_title", this.$store.getters.oneNews["title"]);

      this.formData.set("news_content", this.$store.getters.oneNews["content"]);
    },
    submit() {
      if (this.formData.has("released_at")) {
        this.updateFormData();
      } else {
        this.handleFormData();
      }

      this.$store
        .dispatch("updateOneNews", this.formData)
        .then(() => {
          this.$router.push({ name: "news-owner" });
        })
        .catch(e => {
          console.warn(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.one-news-edit {
  .warn {
    display: inline-block;
    margin-left: 20px;
    color: red;
  }
}
</style>
